import { Link } from "react-router-dom";
import { Instagram, Youtube, ArrowUpRight } from "lucide-react";
import { SOCIALS } from "@/lib/constants";

// TikTok icon (lucide doesn't include it)
const TikTok = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.5a8.16 8.16 0 0 0 4.77 1.52V7.57a4.79 4.79 0 0 1-1.84-.88Z" />
  </svg>
);

const iconFor = (label) => {
  if (label === "Instagram") return <Instagram className="w-5 h-5" />;
  if (label === "TikTok") return <TikTok />;
  if (label === "YouTube") return <Youtube className="w-5 h-5" />;
  return null;
};

export default function Footer() {
  return (
    <footer className="relative bg-[#0A0A0A] text-white overflow-hidden grain" data-testid="site-footer">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#FFD60A] font-bold mb-4">
              Black Women Built · AI Certified
            </p>
            <h2 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.9] uppercase">
              Secure your <span className="text-[#FFD60A]">bag</span><br/>
              with AI.
            </h2>
            <Link
              to="/book"
              data-testid="footer-cta-book"
              className="mt-8 inline-flex items-center gap-2 bg-[#FFD60A] text-black px-6 py-4 font-bold uppercase tracking-wider text-sm hover:bg-white transition-colors"
            >
              Book a Free Consult <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 font-bold mb-4">
              Navigate
            </p>
            <ul className="space-y-3">
              <li><Link to="/" className="hover:text-[#FFD60A]" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/services" className="hover:text-[#FFD60A]" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/book" className="hover:text-[#FFD60A]" data-testid="footer-link-book">Book Now</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 font-bold mb-4">
              Follow Professor Kez
            </p>
            <ul className="space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="inline-flex items-center gap-2 hover:text-[#FFD60A] group"
                  >
                    {iconFor(s.label)}
                    <span>{s.label}</span>
                    <span className="text-white/40 group-hover:text-[#FFD60A]">{s.handle}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#2A2A2A] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-white/50">
          <p>© {new Date().getFullYear()} SkillhouseU. All rights reserved.</p>
          <p>Built in Black excellence.</p>
        </div>
      </div>
    </footer>
  );
}
